export const AllJackpotChart =  [
        {
            "resultDate": "09/30/2024",
            "results": [
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "28",
                     }
            ]
        },
        {
            "resultDate": "10/01/2024",
            "results": [
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "17",
                     }
            ]
        },
        {
            "resultDate": "10/02/2024",
            "results": [
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "95",
                     }
            ]
        },
        {
            "resultDate": "10/03/2024",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "79",
                     }
            ]
        },
        {
            "resultDate": "10/04/2024",
            "results": [
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "13",
                     }
            ]
        },
        {
            "resultDate": "10/05/2024",
            "results": [
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "02",
                     }
            ]
        },
        {
            "resultDate": "10/06/2024",
            "results": [
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "27",
                     }
            ]
        },
        {
            "resultDate": "10/07/2024",
            "results": [
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "62",
                     }
            ]
        },
        {
            "resultDate": "10/08/2024",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "16",
                     }
            ]
        },
        {
            "resultDate": "10/09/2024",
            "results": [
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "74",
                     }
            ]
        },
        {
            "resultDate": "10/10/2024",
            "results": [
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                     "winningDigit": "94",
                     },
                {
                     "winningDigit": "78",
                     },
                {
                     "winningDigit": "30",
                     },
                {
                     "winningDigit": "81",
                     },
                {
                     "winningDigit": "84",
                     },
                {
                     "winningDigit": "59",
                     },
                {
                     "winningDigit": "82",
                     },
                {
                     "winningDigit": "39",
                      }
            ]
        },
        {
            "resultDate": "10/11/2024",
            "results": [
                {
                     "winningDigit": "36",
                     },
                {
                     "winningDigit": "65",
                     },
                {
                     "winningDigit": "66",
                     },
                {
                     "winningDigit": "99",
                     },
                {
                     "winningDigit": "90",
                     },
                {
                     "winningDigit": "55",
                     },
                {
                     "winningDigit": "99",
                     },
                {
                     "winningDigit": "50",
                     },
                {
                     "winningDigit": "16",
                     },
                {
                     "winningDigit": "61",
                     },
                {
                     "winningDigit": "88",
                     },
                {
                     "winningDigit": "44",
                      }
            ]
        },
        {
            "resultDate": "10/12/2024",
            "results": [
                {
                     "winningDigit": "11",
                     },
                {
                     "winningDigit": "18",
                     },
                {
                     "winningDigit": "88",
                     },
                {
                     "winningDigit": "33",
                     },
                {
                     "winningDigit": "90",
                     },
                {
                     "winningDigit": "77",
                     },
                {
                     "winningDigit": "79",
                     },
                {
                     "winningDigit": "39",
                     },
                {
                     "winningDigit": "93",
                     },
                {
                     "winningDigit": "33",
                     },
                {
                     "winningDigit": "49",
                     },
                {
                     "winningDigit": "22",
                      }
            ]
        },
        {
            "resultDate": "10/13/2024",
            "results": [
                {
                     "winningDigit": "89",
                     },
                {
                     "winningDigit": "49",
                     },
                {
                     "winningDigit": "23",
                     },
                {
                     "winningDigit": "97",
                     },
                {
                     "winningDigit": "51",
                     },
                {
                     "winningDigit": "81",
                     },
                {
                     "winningDigit": "11",
                     },
                {
                     "winningDigit": "71",
                     },
                {
                     "winningDigit": "63",
                     },
                {
                     "winningDigit": "33",
                     },
                {
                     "winningDigit": "72",
                     },
                {
                     "winningDigit": "23",
                      }
            ]
        },
        {
            "resultDate": "10/14/2024",
            "results": [
                {
                     "winningDigit": "37",
                     },
                {
                     "winningDigit": "73",
                     },
                {
                     "winningDigit": "44",
                     },
                {
                     "winningDigit": "29",
                     },
                {
                     "winningDigit": "33",
                     },
                {
                     "winningDigit": "57",
                     },
                {
                     "winningDigit": "75",
                     },
                {
                     "winningDigit": "54",
                     },
                {
                     "winningDigit": "40",
                     },
                {
                     "winningDigit": "57",
                     },
                {
                     "winningDigit": "65",
                     },
                {
                     "winningDigit": "79",
                      }
            ]
        },
        {
            "resultDate": "10/15/2024",
            "results": [
                {
                     "winningDigit": "55",
                     },
                {
                     "winningDigit": "32",
                     },
                {
                     "winningDigit": "21",
                     },
                {
                     "winningDigit": "76",
                     },
                {
                     "winningDigit": "44",
                     },
                {
                     "winningDigit": "23",
                     },
                {
                     "winningDigit": "25",
                     },
                {
                     "winningDigit": "30",
                     },
                {
                     "winningDigit": "48",
                     },
                {
                     "winningDigit": "89",
                     },
                {
                     "winningDigit": "34",
                     },
                {
                     "winningDigit": "81",
                      }
            ]
        },
        {
            "resultDate": "10/16/2024",
            "results": [
                {
                     "winningDigit": "80",
                     },
                {
                     "winningDigit": "18",
                     },
                {
                     "winningDigit": "56",
                     },
                {
                     "winningDigit": "18",
                     },
                {
                     "winningDigit": "55",
                     },
                {
                     "winningDigit": "26",
                     },
                {
                     "winningDigit": "66",
                     },
                {
                     "winningDigit": "59",
                     },
                {
                     "winningDigit": "44",
                     },
                {
                     "winningDigit": "43",
                     },
                {
                     "winningDigit": "99",
                     },
                {
                     "winningDigit": "58",
                      }
            ]
        },
        {
            "resultDate": "10/17/2024",
            "results": [
                {
                     "winningDigit": "22",
                     },
                {
                     "winningDigit": "32",
                     },
                {
                     "winningDigit": "54",
                     },
                {
                     "winningDigit": "38",
                     },
                {
                     "winningDigit": "79",
                     },
                {
                     "winningDigit": "91",
                     },
                {
                     "winningDigit": "19",
                     },
                {
                     "winningDigit": "59",
                     },
                {
                     "winningDigit": "60",
                     },
                {
                     "winningDigit": "70",
                     },
                {
                     "winningDigit": "80",
                     },
                {
                     "winningDigit": "98",
                      }
            ]
        },
        {
            "resultDate": "10/18/2024",
            "results": [
                {
                     "winningDigit": "38",
                     },
                {
                     "winningDigit": "55",
                     },
                {
                     "winningDigit": "68",
                     },
                {
                     "winningDigit": "89",
                     },
                {
                     "winningDigit": "99",
                     },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "44",
                     }
            ]
        },
        {
            "resultDate": "10/19/2024",
            "results": [
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "10",
                     }
            ]
        },
        {
            "resultDate": "10/20/2024",
            "results": [
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "13",
                     }
            ]
        },
        {
            "resultDate": "10/21/2024",
            "results": [
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "69",
                     }
            ]
        },
        {
            "resultDate": "10/22/2024",
            "results": [
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "40",
                     }
            ]
        },
        {
            "resultDate": "10/23/2024",
            "results": [
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "10/24/2024",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "76",
                     }
            ]
        },
        {
            "resultDate": "10/25/2024",
            "results": [
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "63",
                     }
            ]
        },
        {
            "resultDate": "10/26/2024",
            "results": [
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "40",
                     }
            ]
        },
        {
            "resultDate": "10/27/2024",
            "results": [
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "59",
                     }
            ]
        },
        {
            "resultDate": "12/30/2024",
            "results": [
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "44",
                     }
            ]
        },
        {
            "resultDate": "12/31/2024",
            "results": [
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "65",
                     }
            ]
        },
        {
            "resultDate": "01/01/2025",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "42",
                     }
            ]
        },
        {
            "resultDate": "01/02/2025",
            "results": [
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "50",
                     }
            ]
        },
        {
            "resultDate": "01/03/2025",
            "results": [
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "48",
                     }
            ]
        },
        {
            "resultDate": "01/04/2025",
            "results": [
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "92",
                     }
            ]
        },
        {
            "resultDate": "01/05/2025",
            "results": [
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "62",
                     }
            ]
        },
        {
            "resultDate": "01/06/2025",
            "results": [
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "41",
                     }
            ]
        },
        {
            "resultDate": "01/07/2025",
            "results": [
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "77",
                     }
            ]
        },
        {
            "resultDate": "01/08/2025",
            "results": [
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "35",
                     }
            ]
        },
        {
            "resultDate": "01/09/2025",
            "results": [
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "19",
                     }
            ]
        },
        {
            "resultDate": "01/10/2025",
            "results": [
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "37",
                     }
            ]
        },
        {
            "resultDate": "01/11/2025",
            "results": [
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "08",
                     }
            ]
        },
        {
            "resultDate": "01/12/2025",
            "results": [
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "24",
                     }
            ]
        },
        {
            "resultDate": "01/13/2025",
            "results": [
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "79",
                     }
            ]
        },
        {
            "resultDate": "01/14/2025",
            "results": [
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "58",
                     }
            ]
        },
        {
            "resultDate": "01/15/2025",
            "results": [
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "35",
                     }
            ]
        },
        {
            "resultDate": "01/16/2025",
            "results": [
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "52",
                     }
            ]
        },
        {
            "resultDate": "01/17/2025",
            "results": [
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "91",
                     }
            ]
        },
        {
            "resultDate": "01/18/2025",
            "results": [
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "73",
                     }
            ]
        },
        {
            "resultDate": "01/19/2025",
            "results": [
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "01/20/2025",
            "results": [
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "39",
                     }
            ]
        },
        {
            "resultDate": "01/21/2025",
            "results": [
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "88",
                     }
            ]
        },
        {
            "resultDate": "01/22/2025",
            "results": [
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "32",
                     }
            ]
        },
        {
            "resultDate": "01/23/2025",
            "results": [
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "36",
                     }
            ]
        },
        {
            "resultDate": "01/24/2025",
            "results": [
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "83",
                     }
            ]
        },
        {
            "resultDate": "01/25/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "04",
                     }
            ]
        },
        {
            "resultDate": "01/26/2025",
            "results": [
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "32",
                     }
            ]
        },
        {
            "resultDate": "01/27/2025",
            "results": [
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "45",
                     }
            ]
        },
        {
            "resultDate": "01/28/2025",
            "results": [
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "80",
                     }
            ]
        },
        {
            "resultDate": "01/29/2025",
            "results": [
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "23",
                     }
            ]
        },
        {
            "resultDate": "01/30/2025",
            "results": [
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "48",
                     }
            ]
        },
        {
            "resultDate": "01/31/2025",
            "results": [
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "51",
                     }
            ]
        },
        {
            "resultDate": "02/01/2025",
            "results": [
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "39",
                     }
            ]
        },
        {
            "resultDate": "02/02/2025",
            "results": [
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "23",
                     }
            ]
        },
        {
            "resultDate": "02/03/2025",
            "results": [
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "56",
                     }
            ]
        },
        {
            "resultDate": "02/04/2025",
            "results": [
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "22",
                     }
            ]
        },
        {
            "resultDate": "02/05/2025",
            "results": [
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "66",
                     }
            ]
        },
        {
            "resultDate": "02/06/2025",
            "results": [
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "97",
                     }
            ]
        },
        {
            "resultDate": "02/07/2025",
            "results": [
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "70",
                     }
            ]
        },
        {
            "resultDate": "02/08/2025",
            "results": [
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "86",
                     }
            ]
        },
        {
            "resultDate": "02/09/2025",
            "results": [
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "43",
                     }
            ]
        },
        {
            "resultDate": "02/10/2025",
            "results": [
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "67",
                     }
            ]
        },
        {
            "resultDate": "02/11/2025",
            "results": [
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "11",
                     }
            ]
        },
        {
            "resultDate": "02/12/2025",
            "results": [
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "28",
                     }
            ]
        },
        {
            "resultDate": "02/13/2025",
            "results": [
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "35",
                     }
            ]
        },
        {
            "resultDate": "02/14/2025",
            "results": [
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "15",
                     }
            ]
        },
        {
            "resultDate": "02/15/2025",
            "results": [
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "17",
                     }
            ]
        },
        {
            "resultDate": "02/16/2025",
            "results": [
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "40",
                     }
            ]
        },
        {
            "resultDate": "02/17/2025",
            "results": [
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "48",
                     }
            ]
        },
        {
            "resultDate": "02/18/2025",
            "results": [
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "90",
                     }
            ]
        },
        {
            "resultDate": "02/19/2025",
            "results": [
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "51",
                     }
            ]
        },
        {
            "resultDate": "02/20/2025",
            "results": [
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "02/21/2025",
            "results": [
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "87",
                     }
            ]
        },
        {
            "resultDate": "02/22/2025",
            "results": [
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "47",
                     }
            ]
        },
        {
            "resultDate": "02/23/2025",
            "results": [
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "76",
                     }
            ]
        },
        {
            "resultDate": "02/24/2025",
            "results": [
                {
                     "winningDigit": "33",
                    },
                {
                     "winningDigit": "76",
                    },
                {
                     "winningDigit": "31",
                    },
                {
                     "winningDigit": "66",
                    },
                {
                     "winningDigit": "56",
                    },
                {
                     "winningDigit": "89",
                    },
                {
                     "winningDigit": "67",
                    },
                {
                     "winningDigit": "54",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "71",
                    },
                {
                     "winningDigit": "59",
                    },
                {
                     "winningDigit": "81",
                     }
            ]
        },
        {
            "resultDate": "02/25/2025",
            "results": [
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "99",
                    },
                {
                     "winningDigit": "67",
                    },
                {
                     "winningDigit": "16",
                    },
                {
                     "winningDigit": "69",
                    },
                {
                     "winningDigit": "82",
                    },
                {
                     "winningDigit": "95",
                    },
                {
                     "winningDigit": "74",
                    },
                {
                     "winningDigit": "39",
                    },
                {
                     "winningDigit": "92",
                    },
                {
                     "winningDigit": "36",
                    },
                {
                     "winningDigit": "50",
                     }
            ]
        },
        {
            "resultDate": "02/26/2025",
            "results": [
                {
                     "winningDigit": "56",
                    },
                {
                     "winningDigit": "93",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "52",
                    },
                {
                     "winningDigit": "69",
                    },
                {
                     "winningDigit": "22",
                    },
                {
                     "winningDigit": "20",
                    },
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "47",
                    },
                {
                     "winningDigit": "88",
                    },
                {
                     "winningDigit": "51",
                    },
                {
                     "winningDigit": "28",
                     }
            ]
        },
        {
            "resultDate": "02/27/2025",
            "results": [
                {
                     "winningDigit": "12",
                    },
                {
                     "winningDigit": "77",
                    },
                {
                     "winningDigit": "91",
                    },
                {
                     "winningDigit": "63",
                    },
                {
                     "winningDigit": "12",
                    },
                {
                     "winningDigit": "86",
                    },
                {
                     "winningDigit": "62",
                    },
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "99",
                    },
                {
                     "winningDigit": "68",
                    },
                {
                     "winningDigit": "90",
                    },
                {
                     "winningDigit": "55",
                     }
            ]
        },
        {
            "resultDate": "02/28/2025",
            "results": [
                {
                     "winningDigit": "14",
                    },
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "54",
                    },
                {
                     "winningDigit": "96",
                    },
                {
                     "winningDigit": "61",
                    },
                {
                     "winningDigit": "27",
                    },
                {
                     "winningDigit": "36",
                    },
                {
                     "winningDigit": "46",
                    },
                {
                     "winningDigit": "19",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "15",
                     }
            ]
        },
        {
            "resultDate": "03/01/2025",
            "results": [
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "81",
                    },
                {
                     "winningDigit": "85",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "77",
                    },
                {
                     "winningDigit": "79",
                    },
                {
                     "winningDigit": "36",
                    },
                {
                     "winningDigit": "73",
                    },
                {
                     "winningDigit": "75",
                    },
                {
                     "winningDigit": "98",
                    },
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "09",
                     }
            ]
        },
        {
            "resultDate": "03/02/2025",
            "results": [
                {
                     "winningDigit": "59",
                    },
                {
                     "winningDigit": "41",
                    },
                {
                     "winningDigit": "19",
                    },
                {
                     "winningDigit": "38",
                    },
                {
                     "winningDigit": "22",
                    },
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "10",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "59",
                    },
                {
                     "winningDigit": "88",
                    },
                {
                     "winningDigit": "90",
                     }
            ]
        },
        {
            "resultDate": "03/03/2025",
            "results": [
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "60",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "24",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "35",
                    },
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "56",
                    },
                {
                     "winningDigit": "67",
                    },
                {
                     "winningDigit": "32",
                     }
            ]
        },
        {
            "resultDate": "03/04/2025",
            "results": [
                {
                     "winningDigit": "90",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "37",
                    },
                {
                     "winningDigit": "20",
                    },
                {
                     "winningDigit": "86",
                    },
                {
                     "winningDigit": "87",
                    },
                {
                     "winningDigit": "33",
                    },
                {
                     "winningDigit": "56",
                    },
                {
                     "winningDigit": "77",
                    },
                {
                     "winningDigit": "82",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "21",
                     }
            ]
        },
        {
            "resultDate": "03/05/2025",
            "results": [
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "69",
                    },
                {
                     "winningDigit": "96",
                    },
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "56",
                    },
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "50",
                     }
            ]
        },
        {
            "resultDate": "03/06/2025",
            "results": [
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "71",
                    },
                {
                     "winningDigit": "17",
                    },
                {
                     "winningDigit": "28",
                    },
                {
                     "winningDigit": "82",
                    },
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "75",
                    },
                {
                     "winningDigit": "57",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "66",
                    },
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "56",
                     }
            ]
        },
        {
            "resultDate": "03/07/2025",
            "results": [
                {
                     "winningDigit": "35",
                    },
                {
                     "winningDigit": "25",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "75",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "62",
                    },
                {
                     "winningDigit": "75",
                    },
                {
                     "winningDigit": "80",
                    },
                {
                     "winningDigit": "59",
                    },
                {
                     "winningDigit": "95",
                    },
                {
                     "winningDigit": "89",
                     }
            ]
        },
        {
            "resultDate": "03/08/2025",
            "results": [
                {
                     "winningDigit": "25",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "60",
                    },
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "80",
                    },
                {
                     "winningDigit": "85",
                    },
                {
                     "winningDigit": "90",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "72",
                    },
                {
                     "winningDigit": "80",
                    },
                {
                     "winningDigit": "85",
                     }
            ]
        },
        {
            "resultDate": "03/09/2025",
            "results": [
                {
                     "winningDigit": "20",
                    },
                {
                     "winningDigit": "25",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "60",
                    },
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "76",
                    },
                {
                     "winningDigit": "85",
                    },
                {
                     "winningDigit": "90",
                    },
                {
                     "winningDigit": "74",
                     }
            ]
        },
        {
            "resultDate": "03/10/2025",
            "results": [
                {
                     "winningDigit": "20",
                    },
                {
                     "winningDigit": "25",
                    },
                {
                     "winningDigit": "35",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "43",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "38",
                    },
                {
                     "winningDigit": "52",
                    },
                {
                     "winningDigit": "60",
                    },
                {
                     "winningDigit": "80",
                     }
            ]
        },
        {
            "resultDate": "03/11/2025",
            "results": [
                {
                     "winningDigit": "22",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "43",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "33",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "60",
                    },
                {
                     "winningDigit": "72",
                    },
                {
                     "winningDigit": "66",
                    },
                {
                     "winningDigit": "80",
                    },
                {
                     "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "03/12/2025",
            "results": [
                {
                     "winningDigit": "25",
                    },
                {
                     "winningDigit": "20",
                    },
                {
                     "winningDigit": "88",
                    },
                {
                     "winningDigit": "39",
                    },
                {
                     "winningDigit": "66",
                    },
                {
                     "winningDigit": "20",
                    },
                {
                     "winningDigit": "91",
                    },
                {
                     "winningDigit": "81",
                    },
                {
                     "winningDigit": "57",
                    },
                {
                     "winningDigit": "49",
                    },
                {
                     "winningDigit": "39",
                    },
                {
                     "winningDigit": "94",
                     }
            ]
        },
        {
            "resultDate": "03/13/2025",
            "results": [
                {
                     "winningDigit": "26",
                    },
                {
                     "winningDigit": "03",
                    },
                {
                     "winningDigit": "18",
                    },
                {
                     "winningDigit": "46",
                    },
                {
                     "winningDigit": "87",
                    },
                {
                     "winningDigit": "83",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "07",
                    },
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "36",
                    },
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "77",
                     }
            ]
        },
        {
            "resultDate": "03/14/2025",
            "results": [
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "57",
                    },
                {
                     "winningDigit": "71",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "61",
                    },
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "90",
                    },
                {
                     "winningDigit": "17",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "46",
                    },
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "62",
                     }
            ]
        },
        {
            "resultDate": "03/15/2025",
            "results": [
                {
                     "winningDigit": "87",
                    },
                {
                     "winningDigit": "91",
                    },
                {
                     "winningDigit": "14",
                    },
                {
                     "winningDigit": "03",
                    },
                {
                     "winningDigit": "63",
                    },
                {
                     "winningDigit": "37",
                    },
                {
                     "winningDigit": "56",
                    },
                {
                     "winningDigit": "37",
                    },
                {
                     "winningDigit": "92",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "52",
                    },
                {
                     "winningDigit": "98",
                     }
            ]
        },
        {
            "resultDate": "03/16/2025",
            "results": [
                {
                     "winningDigit": "79",
                    },
                {
                     "winningDigit": "31",
                    },
                {
                     "winningDigit": "62",
                    },
                {
                     "winningDigit": "52",
                    },
                {
                     "winningDigit": "54",
                    },
                {
                     "winningDigit": "01",
                    },
                {
                     "winningDigit": "22",
                    },
                {
                     "winningDigit": "76",
                    },
                {
                     "winningDigit": "36",
                    },
                {
                     "winningDigit": "38",
                    },
                {
                     "winningDigit": "05",
                    },
                {
                     "winningDigit": "60",
                     }
            ]
        },
        {
            "resultDate": "03/17/2025",
            "results": [
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "02",
                    },
                {
                     "winningDigit": "09",
                    },
                {
                     "winningDigit": "61",
                    },
                {
                     "winningDigit": "52",
                    },
                {
                     "winningDigit": "95",
                    },
                {
                     "winningDigit": "85",
                    },
                {
                     "winningDigit": "68",
                    },
                {
                     "winningDigit": "16",
                    },
                {
                     "winningDigit": "83",
                    },
                {
                     "winningDigit": "07",
                    },
                {
                     "winningDigit": "29",
                     }
            ]
        },
        {
            "resultDate": "03/18/2025",
            "results": [
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "63",
                    },
                {
                     "winningDigit": "18",
                    },
                {
                     "winningDigit": "07",
                    },
                {
                     "winningDigit": "08",
                    },
                {
                     "winningDigit": "87",
                    },
                {
                     "winningDigit": "37",
                    },
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "31",
                    },
                {
                     "winningDigit": "84",
                    },
                {
                     "winningDigit": "73",
                     }
            ]
        },
        {
            "resultDate": "03/19/2025",
            "results": [
                {
                     "winningDigit": "20",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "43",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "60",
                    },
                {
                     "winningDigit": "58",
                    },
                {
                     "winningDigit": "70",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "89",
                    },
                {
                     "winningDigit": "90",
                     }
            ]
        },
        {
            "resultDate": "03/20/2025",
            "results": [
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "22",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "49",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "60",
                    },
                {
                     "winningDigit": "70",
                    },
                {
                     "winningDigit": "75",
                    },
                {
                     "winningDigit": "81",
                    },
                {
                     "winningDigit": "97",
                     }
            ]
        },
        {
            "resultDate": "03/21/2025",
            "results": [
                {
                     "winningDigit": "22",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "37",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "52",
                    },
                {
                     "winningDigit": "62",
                    },
                {
                     "winningDigit": "70",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "80",
                    },
                {
                     "winningDigit": "85",
                    },
                {
                     "winningDigit": "90",
                     }
            ]
        },
        {
            "resultDate": "03/22/2025",
            "results": [
                {
                     "winningDigit": "20",
                    },
                {
                     "winningDigit": "35",
                    },
                {
                     "winningDigit": "22",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "54",
                    },
                {
                     "winningDigit": "64",
                    },
                {
                     "winningDigit": "77",
                    },
                {
                     "winningDigit": "72",
                    },
                {
                     "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "03/23/2025",
            "results": [
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "26",
                    },
                {
                     "winningDigit": "36",
                    },
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "63",
                    },
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "36",
                    },
                {
                     "winningDigit": "54",
                    },
                {
                     "winningDigit": "66",
                    },
                {
                     "winningDigit": "98",
                     }
            ]
        },
        {
            "resultDate": "03/24/2025",
            "results": [
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "33",
                    },
                {
                     "winningDigit": "35",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "58",
                    },
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "75",
                    },
                {
                     "winningDigit": "83",
                    },
                {
                     "winningDigit": "58",
                    },
                {
                     "winningDigit": "97",
                     }
            ]
        },
        {
            "resultDate": "03/25/2025",
            "results": [
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "37",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "46",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "60",
                    },
                {
                     "winningDigit": "67",
                    },
                {
                     "winningDigit": "73",
                    },
                {
                     "winningDigit": "80",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "88",
                     }
            ]
        },
        {
            "resultDate": "03/26/2025",
            "results": [
                {
                     "winningDigit": "25",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "29",
                    },
                {
                     "winningDigit": "40",
                    },
                {
                     "winningDigit": "49",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "57",
                    },
                {
                     "winningDigit": "67",
                    },
                {
                     "winningDigit": "77",
                    },
                {
                     "winningDigit": "83",
                    },
                {
                     "winningDigit": "89",
                    },
                {
                     "winningDigit": "98",
                     }
            ]
        },
        {
            "resultDate": "03/27/2025",
            "results": [
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "64",
                    },
                {
                     "winningDigit": "57",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "24",
                    },
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "29",
                    },
                {
                     "winningDigit": "86",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "72",
                    },
                {
                     "winningDigit": "77",
                    },
                {
                     "winningDigit": "89",
                     }
            ]
        },
        {
            "resultDate": "03/28/2025",
            "results": [
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "12",
                    },
                {
                     "winningDigit": "83",
                    },
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "76",
                    },
                {
                     "winningDigit": "75",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "64",
                    },
                {
                     "winningDigit": "77",
                    },
                {
                     "winningDigit": "88",
                    },
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "11",
                     }
            ]
        },
        {
            "resultDate": "03/29/2025",
            "results": [
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "56",
                    },
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "63",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "88",
                    },
                {
                     "winningDigit": "57",
                    },
                {
                     "winningDigit": "29",
                    },
                {
                     "winningDigit": "47",
                    },
                {
                     "winningDigit": "39",
                     }
            ]
        },
        {
            "resultDate": "03/30/2025",
            "results": [
                {
                     "winningDigit": "44",
                    },
                {
                     "winningDigit": "35",
                    },
                {
                     "winningDigit": "54",
                    },
                {
                     "winningDigit": "74",
                    },
                {
                     "winningDigit": "87",
                    },
                {
                     "winningDigit": "38",
                    },
                {
                     "winningDigit": "63",
                    },
                {
                     "winningDigit": "73",
                    },
                {
                     "winningDigit": "97",
                    },
                {
                     "winningDigit": "99",
                    },
                {
                     "winningDigit": "16",
                    },
                {
                     "winningDigit": "53",
                     }
            ]
        },
        {
            "resultDate": "03/31/2025",
            "results": [
                {
                     "winningDigit": "24",
                    },
                {
                     "winningDigit": "70",
                    },
                {
                     "winningDigit": "33",
                    },
                {
                     "winningDigit": "39",
                    },
                {
                     "winningDigit": "83",
                    },
                {
                     "winningDigit": "51",
                    },
                {
                     "winningDigit": "83",
                    },
                {
                     "winningDigit": "47",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "75",
                    },
                {
                     "winningDigit": "94",
                    },
                {
                     "winningDigit": "48",
                     }
            ]
        },
        {
            "resultDate": "04/01/2025",
            "results": [
                {
                     "winningDigit": "20",
                    },
                {
                     "winningDigit": "21",
                    },
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "43",
                    },
                {
                     "winningDigit": "73",
                    },
                {
                     "winningDigit": "81",
                    },
                {
                     "winningDigit": "79",
                    },
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "93",
                    },
                {
                     "winningDigit": "74",
                    },
                {
                     "winningDigit": "58",
                     }
            ]
        },
        {
            "resultDate": "04/02/2025",
            "results": [
                {
                     "winningDigit": "15",
                    },
                {
                     "winningDigit": "22",
                    },
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "51",
                    },
                {
                     "winningDigit": "62",
                    },
                {
                     "winningDigit": "62",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "39",
                    },
                {
                     "winningDigit": "89",
                    },
                {
                     "winningDigit": "51",
                     }
            ]
        },
        {
            "resultDate": "04/03/2025",
            "results": [
                {
                     "winningDigit": "21",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "27",
                    },
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "15",
                    },
                {
                     "winningDigit": "76",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "86",
                    },
                {
                     "winningDigit": "84",
                    },
                {
                     "winningDigit": "98",
                    },
                {
                     "winningDigit": "18",
                    },
                {
                     "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "04/04/2025",
            "results": [
                {
                     "winningDigit": "13",
                    },
                {
                     "winningDigit": "21",
                    },
                {
                     "winningDigit": "25",
                    },
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "54",
                    },
                {
                     "winningDigit": "73",
                    },
                {
                     "winningDigit": "87",
                    },
                {
                     "winningDigit": "68",
                    },
                {
                     "winningDigit": "72",
                    },
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "88",
                    },
                {
                     "winningDigit": "36",
                     }
            ]
        },
        {
            "resultDate": "04/05/2025",
            "results": [
                {
                     "winningDigit": "16",
                    },
                {
                     "winningDigit": "21",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "24",
                    },
                {
                     "winningDigit": "56",
                    },
                {
                     "winningDigit": "75",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "89",
                    },
                {
                     "winningDigit": "52",
                    },
                {
                     "winningDigit": "66",
                    },
                {
                     "winningDigit": "62",
                     }
            ]
        },
        {
            "resultDate": "04/06/2025",
            "results": [
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "43",
                    },
                {
                     "winningDigit": "33",
                    },
                {
                     "winningDigit": "66",
                    },
                {
                     "winningDigit": "37",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "61",
                    },
                {
                     "winningDigit": "76",
                    },
                {
                     "winningDigit": "88",
                    },
                {
                     "winningDigit": "90",
                    },
                {
                     "winningDigit": "09",
                    },
                {
                     "winningDigit": "38",
                     }
            ]
        },
        {
            "resultDate": "04/07/2025",
            "results": [
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "32",
                    },
                {
                     "winningDigit": "16",
                    },
                {
                     "winningDigit": "54",
                    },
                {
                     "winningDigit": "47",
                    },
                {
                     "winningDigit": "37",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "60",
                    },
                {
                     "winningDigit": "94",
                    },
                {
                     "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "04/08/2025",
            "results": [
                {
                     "winningDigit": "15",
                    },
                {
                     "winningDigit": "23",
                    },
                {
                     "winningDigit": "34",
                    },
                {
                     "winningDigit": "53",
                    },
                {
                     "winningDigit": "33",
                    },
                {
                     "winningDigit": "63",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "45",
                    },
                {
                     "winningDigit": "99",
                    },
                {
                     "winningDigit": "87",
                    },
                {
                     "winningDigit": "77",
                    },
                {
                     "winningDigit": "87",
                     }
            ]
        },
        {
            "resultDate": "04/09/2025",
            "results": [
                {
                     "winningDigit": "35",
                    },
                {
                     "winningDigit": "24",
                    },
                {
                     "winningDigit": "42",
                    },
                {
                     "winningDigit": "33",
                    },
                {
                     "winningDigit": "29",
                    },
                {
                     "winningDigit": "78",
                    },
                {
                     "winningDigit": "55",
                    },
                {
                     "winningDigit": "98",
                    },
                {
                     "winningDigit": "61",
                    },
                {
                     "winningDigit": "84",
                    },
                {
                     "winningDigit": "97",
                    },
                {
                     "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "04/10/2025",
            "results": [
                {
                     "winningDigit": "30",
                    },
                {
                     "winningDigit": "38",
                    },
                {
                     "winningDigit": "29",
                    },
                {
                     "winningDigit": "84",
                    },
                {
                     "winningDigit": "48",
                    },
                {
                     "winningDigit": "64",
                    },
                {
                     "winningDigit": "46",
                    },
                {
                     "winningDigit": "65",
                    },
                {
                     "winningDigit": "50",
                    },
                {
                     "winningDigit": "88",
                    },
                {
                     "winningDigit": "17",
                    },
                {
                     "winningDigit": "76",
                     }
            ]
        },
        {
            "resultDate": "04/11/2025",
            "results": [
                {
                     "winningDigit": "22",
                    },
                {
                     "winningDigit": "85",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "79",
                     }
            ]
        },
        {
            "resultDate": "04/12/2025",
            "results": [
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "17",
                     }
            ]
        },
        {
            "resultDate": "04/13/2025",
            "results": [
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "81",
                     }
            ]
        },
        {
            "resultDate": "04/14/2025",
            "results": [
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "98",
                     }
            ]
        },
        {
            "resultDate": "04/15/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "70",
                     }
            ]
        },
        {
            "resultDate": "04/16/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "29",
                     }
            ]
        },
        {
            "resultDate": "04/17/2025",
            "results": [
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "39",
                     }
            ]
        },
        {
            "resultDate": "04/18/2025",
            "results": [
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "93",
                     }
            ]
        },
        {
            "resultDate": "04/19/2025",
            "results": [
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "63",
                     }
            ]
        },
        {
            "resultDate": "04/20/2025",
            "results": [
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "52",
                     }
            ]
        },
        {
            "resultDate": "04/21/2025",
            "results": [
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "04/22/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "91",
                     }
            ]
        },
        {
            "resultDate": "04/23/2025",
            "results": [
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "04/24/2025",
            "results": [
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "04",
                     }
            ]
        },
        {
            "resultDate": "04/25/2025",
            "results": [
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "04/26/2025",
            "results": [
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "95",
                     }
            ]
        },
        {
            "resultDate": "04/27/2025",
            "results": [
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "95",
                     }
            ]
        },
        {
            "resultDate": "04/28/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "69",
                     }
            ]
        },
        {
            "resultDate": "04/29/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "98",
                     }
            ]
        },
        {
            "resultDate": "04/30/2025",
            "results": [
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "93",
                     }
            ]
        },
        {
            "resultDate": "05/01/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "56",
                     }
            ]
        },
        {
            "resultDate": "05/02/2025",
            "results": [
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "90",
                     }
            ]
        },
        {
            "resultDate": "05/03/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "92",
                     }
            ]
        },
        {
            "resultDate": "05/04/2025",
            "results": [
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "21",
                     }
            ]
        },
        {
            "resultDate": "05/05/2025",
            "results": [
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "45",
                     }
            ]
        },
        {
            "resultDate": "05/06/2025",
            "results": [
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "93",
                     }
            ]
        },
        {
            "resultDate": "05/07/2025",
            "results": [
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "73",
                     }
            ]
        },
        {
            "resultDate": "05/08/2025",
            "results": [
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "50",
                     }
            ]
        },
        {
            "resultDate": "05/09/2025",
            "results": [
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "78",
                     }
            ]
        },
        {
            "resultDate": "05/10/2025",
            "results": [
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "92",
                     }
            ]
        },
        {
            "resultDate": "05/11/2025",
            "results": [
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "30",
                     }
            ]
        },
        {
            "resultDate": "05/12/2025",
            "results": [
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "85",
                     }
            ]
        },
        {
            "resultDate": "05/13/2025",
            "results": [
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "18",
                     }
            ]
        },
        {
            "resultDate": "05/14/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "67",
                     }
            ]
        },
        {
            "resultDate": "05/15/2025",
            "results": [
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "09",
                     }
            ]
        },
        {
            "resultDate": "05/16/2025",
            "results": [
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "30",
                     }
            ]
        },
        {
            "resultDate": "05/17/2025",
            "results": [
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "66",
                     }
            ]
        },
        {
            "resultDate": "05/18/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "02",
                     }
            ]
        },
        {
            "resultDate": "05/19/2025",
            "results": [
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "93",
                     }
            ]
        },
        {
            "resultDate": "05/20/2025",
            "results": [
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "66",
                     }
            ]
        },
        {
            "resultDate": "05/21/2025",
            "results": [
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "38",
                     }
            ]
        },
        {
            "resultDate": "05/22/2025",
            "results": [
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "12",
                     }
            ]
        },
        {
            "resultDate": "05/23/2025",
            "results": [
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "20",
                     }
            ]
        },
        {
            "resultDate": "05/24/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "97",
                     }
            ]
        },
        {
            "resultDate": "05/25/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "29",
                     }
            ]
        },
        {
            "resultDate": "05/26/2025",
            "results": [
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "16",
                     }
            ]
        },
        {
            "resultDate": "05/27/2025",
            "results": [
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "92",
                     }
            ]
        },
        {
            "resultDate": "05/28/2025",
            "results": [
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "50",
                     }
            ]
        },
        {
            "resultDate": "05/29/2025",
            "results": [
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "01",
                     }
            ]
        },
        {
            "resultDate": "05/30/2025",
            "results": [
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "78",
                     }
            ]
        },
        {
            "resultDate": "05/31/2025",
            "results": [
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "94",
                     }
            ]
        },
        {
            "resultDate": "06/01/2025",
            "results": [
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "72",
                     }
            ]
        },
        {
            "resultDate": "06/02/2025",
            "results": [
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "80",
                     }
            ]
        },
        {
            "resultDate": "06/03/2025",
            "results": [
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "19",
                     }
            ]
        },
        {
            "resultDate": "06/04/2025",
            "results": [
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "23",
                     }
            ]
        },
        {
            "resultDate": "06/05/2025",
            "results": [
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "60",
                     }
            ]
        },
        {
            "resultDate": "06/06/2025",
            "results": [
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "64",
                     }
            ]
        },
        {
            "resultDate": "06/07/2025",
            "results": [
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "25",
                     }
            ]
        },
        {
            "resultDate": "06/08/2025",
            "results": [
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "37",
                     }
            ]
        },
        {
            "resultDate": "06/09/2025",
            "results": [
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "65",
                     }
            ]
        },
        {
            "resultDate": "06/10/2025",
            "results": [
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "70",
                     }
            ]
        },
        {
            "resultDate": "06/11/2025",
            "results": [
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "64",
                     }
            ]
        },
        {
            "resultDate": "06/12/2025",
            "results": [
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "61",
                     }
            ]
        },
        {
            "resultDate": "06/13/2025",
            "results": [
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "09",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "69",
                     }
            ]
        },
        {
            "resultDate": "06/14/2025",
            "results": [
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "54",
                     }
            ]
        },
        {
            "resultDate": "06/15/2025",
            "results": [
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "06/16/2025",
            "results": [
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "16",
                     }
            ]
        },
        {
            "resultDate": "06/17/2025",
            "results": [
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "06/18/2025",
            "results": [
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "08",
                     }
            ]
        },
        {
            "resultDate": "06/19/2025",
            "results": [
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "30",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "39",
                     }
            ]
        },
        {
            "resultDate": "06/20/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "36",
                    },
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "87",
                     }
            ]
        },
        {
            "resultDate": "06/21/2025",
            "results": [
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "99",
                     }
            ]
        },
        {
            "resultDate": "06/22/2025",
            "results": [
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "88",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "07",
                    },
                {
                    "winningDigit": "32",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "55",
                    },
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "86",
                    },
                {
                    "winningDigit": "51",
                     }
            ]
        },
        {
            "resultDate": "06/23/2025",
            "results": [
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "31",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "42",
                    },
                {
                    "winningDigit": "28",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "49",
                     }
            ]
        },
        {
            "resultDate": "06/24/2025",
            "results": [
                {
                    "winningDigit": "27",
                    },
                {
                    "winningDigit": "16",
                    },
                {
                    "winningDigit": "83",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "94",
                     }
            ]
        },
        {
            "resultDate": "06/25/2025",
            "results": [
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "65",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "69",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "47",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "82",
                     }
            ]
        },
        {
            "resultDate": "06/26/2025",
            "results": [
                {
                    "winningDigit": "21",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "57",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "62",
                    },
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "24",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "93",
                    },
                {
                    "winningDigit": "34",
                    },
                {
                    "winningDigit": "20",
                     }
            ]
        },
        {
            "resultDate": "06/27/2025",
            "results": [
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "96",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "29",
                    },
                {
                    "winningDigit": "43",
                     }
            ]
        },
        {
            "resultDate": "06/28/2025",
            "results": [
                {
                    "winningDigit": "77",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "64",
                    },
                {
                    "winningDigit": "37",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "58",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "09",
                     }
            ]
        },
        {
            "resultDate": "06/29/2025",
            "results": [
                {
                    "winningDigit": "81",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "66",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "95",
                    },
                {
                    "winningDigit": "38",
                     }
            ]
        },
        {
            "resultDate": "06/30/2025",
            "results": [
                {
                    "winningDigit": "13",
                    },
                {
                    "winningDigit": "04",
                    },
                {
                    "winningDigit": "97",
                    },
                {
                    "winningDigit": "46",
                    },
                {
                    "winningDigit": "06",
                    },
                {
                    "winningDigit": "67",
                    },
                {
                    "winningDigit": "59",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "76",
                    },
                {
                    "winningDigit": "86",
                     }
            ]
        },
        {
            "resultDate": "07/01/2025",
            "results": [
                {
                    "winningDigit": "45",
                    },
                {
                    "winningDigit": "17",
                    },
                {
                    "winningDigit": "25",
                    },
                {
                    "winningDigit": "73",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "61",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "89",
                    },
                {
                    "winningDigit": "05",
                    },
                {
                    "winningDigit": "38",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "95",
                     }
            ]
        },
        {
            "resultDate": "07/02/2025",
            "results": [
                {
                    "winningDigit": "63",
                    },
                {
                    "winningDigit": "11",
                    },
                {
                    "winningDigit": "53",
                    },
                {
                    "winningDigit": "01",
                    },
                {
                    "winningDigit": "39",
                    },
                {
                    "winningDigit": "82",
                    },
                {
                    "winningDigit": "91",
                    },
                {
                    "winningDigit": "78",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "48",
                    },
                {
                    "winningDigit": "15",
                    },
                {
                    "winningDigit": "70",
                     }
            ]
        },
        {
            "resultDate": "07/03/2025",
            "results": [
                {
                    "winningDigit": "41",
                    },
                {
                    "winningDigit": "20",
                    },
                {
                    "winningDigit": "49",
                    },
                {
                    "winningDigit": "79",
                    },
                {
                    "winningDigit": "98",
                    },
                {
                    "winningDigit": "02",
                    },
                {
                    "winningDigit": "84",
                    },
                {
                    "winningDigit": "68",
                    },
                {
                    "winningDigit": "50",
                    },
                {
                    "winningDigit": "00",
                    },
                {
                    "winningDigit": "90",
                    },
                {
                    "winningDigit": "32",
                     }
            ]
        },
        {
            "resultDate": "07/04/2025",
            "results": [
                {
                    "winningDigit": "18",
                    },
                {
                    "winningDigit": "87",
                    },
                {
                    "winningDigit": "35",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "03",
                    },
                {
                    "winningDigit": "92",
                    },
                {
                    "winningDigit": "60",
                    },
                {
                    "winningDigit": "72",
                    },
                {
                    "winningDigit": "23",
                    },
                {
                    "winningDigit": "40",
                    },
                {
                    "winningDigit": "54",
                    },
                {
                    "winningDigit": "83",
                     }
            ]
        },
        {
            "resultDate": "07/05/2025",
            "results": [
                {
                    "winningDigit": "10",
                    },
                {
                    "winningDigit": "80",
                    },
                {
                    "winningDigit": "43",
                    },
                {
                    "winningDigit": "75",
                    },
                {
                    "winningDigit": "85",
                    },
                {
                    "winningDigit": "52",
                    },
                {
                    "winningDigit": "08",
                    },
                {
                    "winningDigit": "12",
                    },
                {
                    "winningDigit": "70",
                    },
                {
                    "winningDigit": "26",
                    },
                {
                    "winningDigit": "94",
                    },
                {
                    "winningDigit": "31",
                     }
            ]
        },
        {
            "resultDate": "07/06/2025",
            "results": [
                {
                    "winningDigit": "14",
                    },
                {
                    "winningDigit": "33",
                    },
                {
                    "winningDigit": "51",
                    },
                {
                    "winningDigit": "22",
                    },
                {
                    "winningDigit": "56",
                    },
                {
                    "winningDigit": "71",
                    },
                {
                    "winningDigit": "99",
                    },
                {
                    "winningDigit": "19",
                    },
                {
                    "winningDigit": "44",
                    },
                {
                    "winningDigit": "9",
                    },
                {
                    "winningDigit": "74",
                    },
                {
                    "winningDigit": "65",
                     }
            ]
        },
       
      
    ]